// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1phSV","boxTitle":"Qualiphy_boxTitle__33nSp","box":"Qualiphy_box__QTO8c","toggleWrap":"Qualiphy_toggleWrap__jMbqV"};